import { RadioContainer } from "../commons";
import { RadioTypes } from "../../commonTypes/universalTypes";
import "./style.scss";

type AppProps = {
  handleReset: () => void;
  singleFixedAsset: any;
  handleSubmit: (condition: string, id: string) => void;
  condition: string;
  setCondition: (data: string) => void;
  handleSetConditionRadioValue: (data: string) => void;
};

export const JOB_STATUS_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "Missing",
    name: "Missing",
  },
  {
    id: "Good",
    name: "Good",
  },
  {
    id: "Bad",
    name: "Bad",
  },
  {
    id: "Obsolete",
    name: "Obsolete",
  },
  {
    id: "Yet to Capitalize",
    name: "Yet to Capitalize",
  },
];

const SingleAssetDetail = ({
  singleFixedAsset,
  handleSubmit,
  condition,
  handleSetConditionRadioValue,
}: AppProps) => {
  return (
    <div
      className="flex-center"
      style={{ flexDirection: "column", width: "80vw" }}
    >
      <div style={{ width: "80vw" }}>
        <div className="mt-2 mb-2" style={{ display: "flex", gap: "20%" }}>
          <div>
            <div className="scan-header">Asset ID</div>

            <div className="text">{singleFixedAsset.asset_id}</div>
          </div>

          <div>
            <div className="scan-header">Finac Asset ID</div>

            <div className="text">{singleFixedAsset.finac_asset_id}</div>
          </div>
        </div>

        <div className="mb-2">
          <div className="scan-header">Description</div>

          <div className="text">{singleFixedAsset?.asset_description}</div>
        </div>
        {singleFixedAsset?.asset_category ? (
          <div className="mb-2">
            <div className="scan-header">Category</div>

            <div className="text">{singleFixedAsset?.asset_category}</div>
          </div>
        ) : (
          ""
        )}
        {singleFixedAsset?.gl_code ? (
          <div className="mb-2">
            <div className="scan-header">GL Code</div>

            <div className="text">{singleFixedAsset?.gl_code}</div>
          </div>
        ) : (
          ""
        )}
        {singleFixedAsset?.department ? (
          <div className="mb-2">
            {singleFixedAsset?.department?.value ? (
              <div className="scan-header">Department</div>
            ) : null}
            <div className="text">{singleFixedAsset?.department?.label}</div>
          </div>
        ) : (
          ""
        )}
        {singleFixedAsset?.sub_location ? (
          <div className="mb-2">
            <div className="scan-header">Sub-Location</div>

            <div className="text">{singleFixedAsset?.sub_location}</div>
          </div>
        ) : (
          ""
        )}
      </div>

      {/* Radio Btn  */}

      <div className="mt-3 d-flex asset-condition">
        <div className="bold">Set Asset Condition</div>
        <div style={{ width: "150%" }}>
          <RadioContainer
            optionsList={JOB_STATUS_RADIO_OPTIONS}
            handleSetRadioValue={handleSetConditionRadioValue}
            radioValue={condition}
            alignment="vertical"
          />
        </div>
      </div>

      <div className="mt-2">
        <button
          className="btn btn-primary"
          onClick={() => handleSubmit(condition, singleFixedAsset?.id)}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default SingleAssetDetail;
